import React from 'react'
import './Content.css'
import UserContext from '../../context/UserContext'
import { useContext } from 'react'

function Content({children}) {

  const appContext = useContext(UserContext)


  return (
    <div className="ecd-widget-content">{children}</div>
  )
}

export default Content